export default __webpack_public_path__ + "static/media/wohnungen_intro_web-xs@1x.c9997f19.jpg";